<template>
  <div>
    <v-card class="d-flex" flat>
      <template v-if="layers.length > 1">
        <v-card flat>
          <v-radio-group
            v-model="target.layer"
            :column="false"
            :label="label"
            @change="update('layer')"
          >
            <v-radio
              v-for="layer in layers"
              :label="layer_type === 'layer' ? $t('message.common.' + layer) : $t('message.common.role_' + layer_role[layer])"
              :key="layer"
              :value="layer"
              class="pl-5"
            ></v-radio>
          </v-radio-group>
        </v-card>
      </template>
    </v-card>
    <v-card class="d-flex" flat>
      <template v-if="mode === 'organization'
        && target.layer === 'group'">
        <v-card flat class="pr-4">
          <v-autocomplete
            :value="target.gid"
            :label="$t('message.common.group')"
            class="mb-2"
            :items="groups"
            item-text="label"
            item-value="value"
            :return-object="false"
            :disabled="groups.length == 0"
            @input="target.gid = $event; update('group')"
          >
          </v-autocomplete>
        </v-card>
      </template>
      <template v-if="mode !== 'user'
        && target.layer === 'user'">
        <v-card flat class="pr-4">
          <v-autocomplete
            :value="target.uid"
            :label="$t('message.common.user')"
            class="mb-2"
            :items="users"
            item-text="label"
            item-value="value"
            :return-object="false"
            :disabled="users.length == 0"
            @input="target.uid = $event; update('user')"
          >
          </v-autocomplete>
        </v-card>
      </template>
    </v-card>
  </div>
</template>

<script>
import { http_error } from "../js/http_error";

export default {
  name: 'general_select',
  mixins: [http_error],
  props: {
    mode: String,
    label: String,
    layer_type: String,
    target_layer: Array,
    target: Object
  },
  data: function(){
    return {
      module_id: "7A",
      layers: [],
      groups: [],
      users: [],
      layer_role: {
        "organization": "organization_manager",
        "group": "group_manager",
        "user": "user"
      }
    }
  },
  mounted: function(){
    // layer
    for(var layer of this.target_layer){
      if(this.mode === "organization"){
        // 全てが対象
      }else if(this.mode === "group"){
        // 全てが対象
        this.target.gid = this.$store.getters.user.gid;
      }else if(this.mode === "user"){
        // organizationとgroup対象外
        if(["organization", "group"].indexOf(layer) >= 0){
          continue;
        }
        this.target.gid = this.$store.getters.user.gid;
        this.target.uid = this.$store.getters.user.uid;
      }
      this.layers.push(layer);
    }
    if(this.$route.query.layer){
      this.target.layer = this.$route.query.layer;
    }else{
      this.target.layer = this.layers[0];
    }
    this.update("layer");
  },
  methods: {
    get_data: function(path, id_name, arg_name) {
      this.$http.get(this.$store.getters.api_endpoint + path)
        .then( response => {
          if(this.$store.getters.debug){
            console.log("response.data:" + JSON.stringify(response.data));
          }
          var data = [];
          for(var record of response.data){
            if(this.target.layer === "user" && !record.name){
              data.push({
                "label": "(" + record.user + ") (" + record[id_name] + ")",
                "value": record[id_name]
              });
            }else{
              data.push({
                "label": record.name + " (" + record[id_name] + ")",
                "value": record[id_name]
              });
            }
          }
          this[arg_name] = data.sort(function(a, b){
            if(a.label === "" || b.label === ""){
              return 1;
            }else if (a.label > b.label) {
              return 1;
            }else{
              return -1;
            }
          });
        })
        .catch( error => {
          if(this.http_error(error)){
            this.$store.commit("setNotification", {
              type: "error",
              message: error.response.data
            });
          }
        });
    },
    update: function(layer){
      if(layer === "layer"){
        this.groups = [];
        this.users = [];
        this.$emit("clear_target");
        if(this.target.layer === "organization"){
          this.$emit("update_target", this.target);
        }else if(this.target.layer === "group"){
          if(this.mode === "group"){
            this.$emit("update_target", this.target);
          }else{
            this.get_data("/" + this.get_prefix() + "group/list", "gid", "groups");
          }
        }else if(this.target.layer === "user"){
          if(this.mode === "user"){
            this.$emit("update_target", this.target);
          }else{
            this.get_data("/" + this.get_prefix() + "user/list", "uid", "users");
          }
        }
      }else if(layer === "group"){
        if(this.target.layer === "group"){
          this.$emit("update_target", this.target);
        }
      }else if(layer === "user"){
        if(this.target.layer === "user"){
          this.$emit("update_target", this.target);
        }
      }
    },
    get_prefix: function(){
      if(this.mode === "user"){
        return "";
      }else{
        return this.mode + "/";
      }
    }
  }
}
</script>
